module.exports = __webpack_public_path__ + "img/malla_curricular.c156b45d.png";